module.exports = __webpack_public_path__ + "static/tree-5c63b048d403feac4e0a85ed782b212c.png";